(function () {
    "use strict";

    angular
        .module("atheer.content")
        .controller("ZipDetailController", ZipDetailController)
        .controller("ZipViewController", ZipViewController);

    /* @ngInject */
    function ZipViewController($scope, $controller, $mdDialog, $filter, $http) {
        var basectrl = $controller("BaseContentViewController as vm", {
            $scope: $scope,
        });
        angular.extend(this, basectrl);

        $scope.downloadOnClick = function () {
            var confirm = $mdDialog
                .confirm()
                .title($filter("translate")("atheer.content.downloadZip"))
                .ariaLabel($filter("translate")("atheer.content.downloadZip"))
                .ok($filter("translate")("atheer.content.download"))
                .cancel($filter("translate")("entity.action.cancel"));

            $mdDialog.show(confirm).then(function () {
                const url =
                    "/media/zips/" +
                    $scope.data.data.source_media.properties.file_name;
                $http
                    .get(url, {
                        responseType: "blob",
                    })
                    .then(function (response) {
                        const blob = response.data;
                        const url = window.URL.createObjectURL(blob);
                        const link = document.createElement("a");
                        link.href = url;
                        link.download = $scope.data.title;
                        link.target = "_blank";
                        link.click();
                        window.URL.revokeObjectURL(url);
                    });
            });
        };
    }

    /* @ngInject */
    function ZipDetailController(
        $scope,
        $timeout,
        $controller,
        id,
        Content,
        $sce,
        poller,
        $resource
    ) {
        var basectrl = $controller("BaseContentDetailController as vm", {
            $scope: $scope,
            id: id,
            content_type: "zip",
        });
        angular.extend(this, basectrl);

        var vm = this;

        vm.uploadStatus = "idle";
        vm.extractStatus = "IDLE";
        vm.processStatus = "IDLE";
        vm.fileMaxSize = 500 * 1024 * 1024;
        vm.zipStatusPoller = null;

        vm.createZip = function (mediaId, responseObj) {
            vm.processStatus = "UPLOADED";

            vm.contentModel.title = responseObj.name;
            vm.contentModel.data.source_media = responseObj;
            vm.contentModel.data.zip_status = "UPLOADED";
            vm.contentModel.external_id = responseObj.external_id;

            vm.save();
            vm.checkZipStatus();
        };

        $scope.$watch("vm.contentModel", function (newVal) {
            if (!vm.isNew()) {
                vm.checkZipStatus();
            }
        });

        vm.checkZipStatus = function () {
            // Stop any existing poller before creating a new one
            if (vm.zipStatusPoller) {
                vm.zipStatusPoller.stop();
                vm.zipStatusPoller = null;
            }

            // If the zip is uploaded or processing, check the status.
            if (
                (vm.contentModel.data.zip_status === "UPLOADED" ||
                    vm.contentModel.data.zip_status === "PROCESSING") &&
                vm.contentModel.id
            ) {
                vm.processStatus = vm.contentModel.data.zip_status;

                // Get poller and store the instance.
                vm.zipStatusPoller = poller.get(Content, {
                    action: "get",
                    delay: 3000,
                    argumentsArray: [
                        {
                            id: vm.contentModel.id,
                        },
                    ],
                    smart: true,
                });

                vm.zipStatusPoller.promise.then(null, null, function (result) {
                    if (result.data.zip_status == "READY") {
                        vm.zipStatusPoller.stop();
                        vm.zipStatusPoller = null;
                        vm.processStatus = "COMPLETE";
                        $timeout(function () {
                            vm.processStatus = "READY";
                            vm.contentModel = result;
                        }, 2000);
                    }
                    if (result.data.zip_status == "FAILED") {
                        vm.zipStatusPoller.stop();
                        vm.zipStatusPoller = null;
                        vm.processStatus = "FAILED";
                        vm.contentModel = result;
                    }
                });
            } else {
                vm.processStatus = vm.contentModel.data.zip_status;
            }
        };

        $scope.$on("$destroy", function () {
            if (vm.zipStatusPoller) {
                vm.zipStatusPoller.stop();
                vm.zipStatusPoller = null;
            }
        });
    }
})();
